// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__-PuaX","tab":"ProcedureTabs_tab__BVrrm"};